// extracted by mini-css-extract-plugin
module.exports = {"switchBase":"Switch_switchBase__2o4UJ","checked":"Switch_checked__27pXt"};